export default {
	dateFormat (data) {
		let { millisecond, format = 'yyyy-MM-dd hh:mm:ss' } = data

	    if (!Number.isInteger(millisecond)) {
	        return false
	    }

	    let date = new Date(millisecond)
	    let obj = {
	        'M+': date.getMonth() + 1,
	        'd+': date.getDate(),
	        'h+': date.getHours(),
	        'm+': date.getMinutes(),
	        's+': date.getSeconds(),
	        'q+': Math.floor((date.getMonth() + 3) / 3),
	        'S': date.getMilliseconds()
	    }

	    if (/(y+)/.test(format)) {
	        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
	    }

	    for (var k in obj) {
	        if (new RegExp('(' + k + ')').test(format)) {
	            format = format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (obj[k]) : (('00' + obj[k]).substr(('' + obj[k]).length)))
	        }
	    }

	    return format
	},
	/**
	 * 模仿PHP的strtotime()函数
	 * strtotime('2012-07-27 12:43:43') OR strtotime('2012-07-27')
	 * return 时间戳
	 */
	strtotime (str) {
		var _arr = str.split(' ');
		var _day = _arr[0].split('-');
		_arr[1] = (_arr[1] === null) ? '0:0:0' : _arr[1];
		var _time = _arr[1].split(':');
		for (let i = _day.length - 1; i >= 0; i--) {
			_day[i] = isNaN(parseInt(_day[i])) ? 0 : parseInt(_day[i]);
		};
		for (var i = _time.length - 1; i >= 0; i--) {
			_time[i] = isNaN(parseInt(_time[i])) ? 0 : parseInt(_time[i]);
		};
		var _temp = new Date(_day[0], _day[1] - 1, _day[2], _time[0], _time[1], _time[2]);
		return _temp.getTime() / 1000;
	}
}


// WEBPACK FOOTER //
// ./src/utils/index.js